<template>
  <div class="container">
    <v-dialog v-model="selectAccountDialog" max-width="400">
        <v-card class="ma-4" max-width="350" v-bind:key="account.id" v-for="account in selectAccountDialogEntries">
            <v-card-title class="text-wrap">
                <p>{{account.name}}</p>
            </v-card-title>
            
            <v-card-subtitle>{{ `ΑΦΜ: ${account.tax_registration_number || '-'}` }}</v-card-subtitle>
            
            <v-card-text>
                <v-container>
                    <v-row>
                        <div>{{account.city}} {{account.zipcode}}</div>
                    </v-row>
                    <v-row>
                        <div>{{account.address}}</div>
                    </v-row>
                    <v-row>
                        <div>{{account.telephone}}</div>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="updateAccount(selectAccountDialogShownFor, account); closeSelectAcountDialog();">ΕΠΙΛΟΓΗ</v-btn>
            </v-card-actions>
        </v-card>
    
    </v-dialog>

    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
            Φίλτρα αναζήτησης
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" sm="6">
              <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="documentIssueDateStartFilter"
                          label="Ημερομηνία έκδοσης (Από)"
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          clearable>
                      </v-text-field>
                  </template>
                  <v-date-picker
                      v-model="documentIssueDateStartFilter"
                      @input="menu1 = false">
                  </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6">
                <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="documentIssueDateStopFilter"
                            label="Ημερομηνία έκδοσης (Έως)"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="documentIssueDateStopFilter"
                        @input="menu2 = false">
                    </v-date-picker>
                </v-menu>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
                <v-select 
                    v-bind:items="documentTypes" 
                    v-model="documentTypeFilter"
                    return-object
                    
                    item-text="description" 
                    label="Είδος παραστατικού"
                    clearable>
                </v-select>
            </v-col>
            <v-col cols="12" sm="6">
                <v-text-field 
                    v-model="consignor.name" 
                    label="Εντολέας"
                    append-icon="mdi-account-search"
                    @click:append="searchAccountByName('consignor')"
                    @keydown="clearAccount('consignor')"
                    v-bind:disabled="consignorNotEditable">
                </v-text-field>
            </v-col>
        </v-row>

                    <v-row class="my-3" cols="12" align="center" justify="center">
            <v-btn 
                color="success" 
                rounded
                elevation="2"
                class="mx-2 px-5 font-weight-bold white--text"
                @click="getData" 
                :loading="getDataButtonDisabled"
            >
                <v-icon left size="20">mdi-magnify</v-icon>
                <span>ΑΝΑΖΗΤΗΣΗ</span>
            </v-btn>

            <v-btn 
                color="orange darken-2" 
                dark
                rounded
                elevation="2"
                class="mx-2 px-5 font-weight-bold white--text"
                @click="clearFilters" 
            >
                <v-icon left size="20">mdi-broom</v-icon>
                <span>ΚΑΘΑΡΙΣΜΑ</span>
            </v-btn>

            <table-export-menu
            title="Παραστατικά μεταφορών"
            :headers="headers"
            :items="items"
            button-class="mx-2"
          />
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      loading-text="Φόρτωση φορτωτικών..."
      no-data-text="Δεν υπάρχουν δεδομένα"
      :sort-by="['issue_date']"
      :sort-desc="true"
      multi-sort
      class="elevation-1">
      
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Παραστατικά</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Διαγραφή εγγραφής {{editedItem.document}};</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" text @click="closeDelete">ΑΚΥΡΟ</v-btn>
                <v-btn color="error darken-1" @click="deleteItemConfirm" v-bind:loading="deleteButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogMail" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Αποστολή email</v-card-title>
              <v-card-text>
                <v-text-field 
                  v-model="editedItem.consignor_email"
                  label="Διεύθυνση αποστολής"
                  hint="Για πολλαπλά email διαχωρίστε με ; (π.χ. email1@test.gr; email2@test.gr)"
                  persistent-hint>
                </v-text-field>
                <v-checkbox v-model="saveMailAddress" label="Αποθήκευση διεύθυνσης email"/>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" text @click="closeMail">ΑΚΥΡΟ</v-btn>
                <v-btn color="success darken-1" @click="mailConfirm" v-bind:loading="mailButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>


        </v-toolbar>
      </template>
      
      <template v-slot:[`item.issue_date`]="{ item }">
        {{ formatDate(item.issue_date) }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small color="primary" @click="sendMail(item)"> mdi-email </v-icon>
        <v-icon small color="primary" @click="show(item)"> mdi-printer </v-icon>
        <router-link :to="{name: 'edittransportationdocument', params: {id: item.id}}" v-if="item.invoice_mark==null"> 	
          <v-icon small class="mr-2"> mdi-pencil </v-icon>
        </router-link>
        <v-icon small color="error" @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import moment from "moment";

  export default {
    data: () => ({
      loading: true,
      editedItem: {},
      dialog: false,
      dialogDelete: false,
      dialogMail: false,
      saveMailAddress: false,

      deleteButtonDisabled: false,
      mailButtonDisabled: false,

      headers: [
        { 
            text: 'Actions',
            align: 'center', 
            value: 'actions', 
            sortable: false 
        },
        {
          text: 'Ημερομηνία',
          align: 'start',
          // value: 'issue_date',
          value: 'Ημερομηνία'
        },
        { 
          text: 'Όχημα', 
          align: 'center',
          // value: 'vehicle' 
          value: 'Όχημα'
        },
        { 
          text: 'Παραστατικό', 
          align: 'center',
          // value: 'document'
          value: 'Παραστατικό'
        },
        {
          text: 'Εντολέας',
          align: 'center',
          // value: 'consignor',
          value: 'Εντολέας'
        },
        { 
          text: 'Αποστολέας', 
          align: 'center',
          // value: 'sender' 
          value: 'Αποστολέας'
        },
        { 
          text: 'Παραλήπτης',
          align: 'center', 
          // value: 'recipient' 
          value: 'Παραλήπτης'
        },
        { 
          text: 'Φόρτωση',
          align: 'center', 
          // value: 'pickup_location'
          value: 'Φόρτωση' 
        },
        { 
          text: 'Παράδοση',
          align: 'center', 
          // value: 'delivery_location' 
          value: 'Παράδοση'
        },
        { 
          text: 'Διεύθυνση', 
          align: 'center',
          // value: 'recipient_address' 
          value: 'Διεύθυνση'
        },
        { 
          text: 'Τεμάχια',
          align: 'center', 
          // value: 'package_count' 
          value: 'Τεμάχια'
        },
        { 
          text: 'Βάρος', 
          align: 'center',
          // value: 'weight'
          value: 'Βάρος' 
        },
        { 
          text: 'Κυβικό', 
          align: 'center',
          // value: 'volume'
          value: 'Κυβικό' 
        },
        { 
          text: 'Καθαρό', 
          align: 'center',
          // value: 'net_value' 
          value: 'Καθ.Αξία'
        },
        { 
          text: 'Έξ. Τρίτων', 
          align: 'center',
          // value: 'third_party_charges' 
          value: 'Εξ.Τρίτων'
        },
        { 
          text: 'Μικτό', 
          align: 'center',
          // value: 'gross_value'
          value: 'Μικτό' 
        },
        //{ text: 'created_at', value: 'created_at', align: 'd-none' }
        
      ],

      items: [],

      
      selectAccountDialog: false,
      selectAccountDialogEntries: [],
      selectAccountDialogShownFor: '',

      documentTypes: [],

      consignor: {},
      consignorNotEditable: false,

      documentTypeFilter: null,

      documentIssueDateStartFilter: null,
      documentIssueDateStopFilter: null,

      getDataButtonDisabled: false,
      getExcelButtonDisabled: false,

      menu2: null,
      menu1: null,


    }),

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {

      formatDate(value) {
        return moment(value).format("DD/MM/YYYY")
      },

      mixmatch(customer) {
        customer.country = this.countries.find(country => country.id == customer.country_id)
        customer.taxOffice = this.taxOffices.find(taxOffice => taxOffice.id == customer.tax_registration_office_id )
        
        return customer
      },

      initialize () {
        
        this.$store.dispatch('currentUser/getCurrentUser')

        const initialDaysBeforeFilterValue = 30

        const today = new Date();

        let filterStart = new Date()
        filterStart.setDate(today.getDate() - initialDaysBeforeFilterValue);

        this.documentIssueDateStartFilter = this.$localDateString(filterStart)
        // this.documentIssueDateStopFilter = today.toISOString().split('T')[0]

        this.getData()

        this.getFilterValues()
      },

      getFilterValues() {
        axios.get('/api/document-types/transportation')
        .then(response => this.documentTypes = response.data)

      },

      getRequestParams() {
          return {
              issue_date_start: this.documentIssueDateStartFilter,
              issue_date_stop: this.documentIssueDateStopFilter,
              document_type_id: this.documentTypeFilter?.id,
              consignor_id: this.consignor?.id
          }

      },

      getData() {
        this.loading = true;

        this.getDataButtonDisabled = true;
        axios.get(
            '/api/documents/transportation/grid', 
            {
                params: this.getRequestParams()
            }
        )
        .then(response => this.items = response.data)
        .finally(() => {
          this.getDataButtonDisabled = false;
          this.loading = false;
        })
        .catch(error => { console.log(error) })
        
      },

      editItem (item) {
        // this.editedIndex = this.items.indexOf(item)
        // this.editedItem = Object.assign({}, item)
        // this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.deleteButtonDisabled = true
        axios.delete(`/api/documents/transportation/${this.items[this.editedIndex].id}`)
        .then(response => { this.items.splice(this.editedIndex, 1); this.closeDelete(); })
        .catch(error => console.log(error))
        .finally(() => this.deleteButtonDisabled = false)
      },

      mailConfirm() {
        this.mailButtonDisabled = true
        axios
          .post('/api/mailer/transportation', { 
            document_id: this.editedItem.id, 
            email_address: this.editedItem.consignor_email, 
            save_email: this.saveMailAddress ? true : false 
          })
          .then(response => { 
            console.log(response); 
            if (this.saveMailAddress && this.editedIndex > -1) {
              this.items[this.editedIndex].consignor_email = this.editedItem.consignor_email;
            }
            this.closeMail(); 
          })
          .catch(error => { 
            console.log(error);
            let msg = 'Σφάλμα κατά την αποστολή του email.';
            if (error.response && error.response.data && error.response.data.message) {
              msg = error.response.data.message;
            }
            if (this.$swal) {
              this.$swal.fire('Σφάλμα', msg, 'error');
            }
          })
          .finally(() => { this.mailButtonDisabled = false })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },


      sendMail(item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogMail = true
      },

      show(item) {
        window.open(`/vouchers/pdf/${item.uuid}`, '_blank').focus();
      },


      closeMail() {
        this.editedItem = {};
        this.editedIndex = -1;
        this.saveMailAddress = false;
        this.dialogMail = false;
      },

      async searchAccountByName(accountPropertyName) {
            let needle = this[accountPropertyName].name
            let response = await axios.get(`/api/accounts/search/name/${needle}`)

            if (response.data.length == 1)
                this.updateAccount(accountPropertyName, response.data[0])
            else if (response.data.length > 1) {

                this.selectAccountDialogEntries = response.data
                this.selectAccountDialogShownFor = accountPropertyName
                this.selectAccountDialog = true
            }
        },

        updateAccount(accountPropertyName, data) {
            this[accountPropertyName] = {
                id: data.id,
                address : data.address,
                name : data.name,
                city : data.city,
                telephone : data.telephone,
                fax : data.fax,
                email : data.email,
                country_id : data.country_id,
                mobile : data.mobile,
                tax_registration_number: data.tax_registration_number,
                zipcode: data.zipcode,
                tax_registration_office_id: data.tax_registration_office_id,
                jobtitle: data.jobtitle
            }
        },
        
        closeSelectAcountDialog() {
            this.selectAccountDialog = false
            this.selectAccountDialogEntries = []
            this.selectAccountDialogShownFor = null
        },

        clearAccount(accountPropertyName) {
          if (this[accountPropertyName]?.id > 0)
            this[accountPropertyName].id = null
        },

        clearFilters() {
          this.consignor = {}
          this.documentIssueDateStartFilter = null
          this.documentIssueDateStopFilter = null
          this.documentTypeFilter = null
        },

        getExcel() {
            this.axiosDownload('/api/documents/transportation/export', this.getRequestParams(), 'μεταφορικό.xlsx')
        },

        axiosDownload(url, params, filename) {
            this.getExcelButtonDisabled = true;

          // console.log('btn disabled')
            
            axios({
                url: url, 
                params: params,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename); //or any other extension
                document.body.appendChild(link);
                link.click();
                this.getExcelButtonDisabled = false
            // link.remove();
            // url.remove();
            }).catch(err => { console.log(err); this.getExcelButtonDisabled = false})
        
      },


    }
  }
</script>

<style scoped>
</style>